import { Heading, Box, Paragraph } from 'grommet'
import styled from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  margin-bottom: -${({ theme }) => theme.spaces[5]}px;

  ${({ theme }) => theme.below.laptop`
    margin-bottom: ${({ theme }) => theme.spaces[4]}px;
    padding: 0;
  `}
`

export const Cards = styled(Box)`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;

  ${({ theme }) => theme.below.laptop`
    justify-content: center;
  `}
`

export const Card = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 ${({ theme }) => theme.spaces[4]}px;
  width: 430px;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spaces[4]}px;
  }
`

export const TableTitle = styled(Heading)`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'large')}

  -webkit-background-clip: text;
  align-self: center;
  background-clip: text;
  background-image: ${({ theme }) => theme.newColors.gradientGreen};
  color: transparent;
  text-transform: uppercase;
`

export const TableSubtitle = styled(Paragraph)`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'title2')}

  color: ${({ theme }) => theme.newColors.primary};
  font-size: ${({ theme }) => theme.typography.mobile.title.title1.fontSize}px;
  margin-top: ${({ theme }) => theme.spaces[3]}px;
  text-align: center;
  text-transform: uppercase;
  white-space: pre-wrap;

  ${({ theme }) => theme.below.laptop`
    text-align: center;
  `}
`
